import { Route, Routes } from "react-router-dom";
import { PTLI1004001Q } from "@/tra/tancis/ptli/ptl/role/PTLI1004001Q";
import { PTLI1004003S } from "@/tra/tancis/ptli/ptl/role/PTLI1004003S";
import { PTLI1004002S } from "@/tra/tancis/ptli/ptl/role/PTLI1004002S";
import { PTLI1014001Q } from "@/tra/tancis/ptli/ptl/lbl/PTLI1014001Q";
import { PTLI1014002S } from "@/tra/tancis/ptli/ptl/lbl/PTLI1014002S";
import { PTLI1014003S } from "@/tra/tancis/ptli/ptl/lbl/PTLI1014003S";
import { PTLI1001001Q } from "@/tra/tancis/ptli/ptl/menu/PTLI1001001Q";
import { PTLI1001002S } from "@/tra/tancis/ptli/ptl/menu/PTLI1001002S";
import { PTLI1001003S } from "@/tra/tancis/ptli/ptl/menu/PTLI1001003S";
import { PTLI1003001Q } from "@/tra/tancis/ptli/ptl/menuscrn/PTLI1003001Q";
import { PTLI1003002S } from "@/tra/tancis/ptli/ptl/menuscrn/PTLI1003002S";
import { PTLI1017001Q } from "@/tra/tancis/ptli/ptl/bltbrd/PTLI1017001Q";
import { PTLI1017002S } from "@/tra/tancis/ptli/ptl/bltbrd/PTLI1017002S";
import { PTLI1017003S } from "@/tra/tancis/ptli/ptl/bltbrd/PTLI1017003S";
import { PTLI1017004Q } from "@/tra/tancis/ptli/ptl/bltbrd/PTLI1017004Q";
import { PTLI1017005Q } from "@/tra/tancis/ptli/ptl/bltbrd/PTLI1017005Q";
import { PTLI1018001Q } from "@/tra/tancis/ptli/ptl/btbdms/PTLI1018001Q";
import { PTLI1018002Q } from "@/tra/tancis/ptli/ptl/btbdms/PTLI1018002Q";
import { PTLI1018003S } from "@/tra/tancis/ptli/ptl/btbdms/PTLI1018003S";
import { PTLI1018004S } from "@/tra/tancis/ptli/ptl/btbdms/PTLI1018004S";
import { PTLI1005001Q } from "@/tra/tancis/ptli/ptl/auth/PTLI1005001Q";
import { PTLI1005002S } from "@/tra/tancis/ptli/ptl/auth/PTLI1005002S";
import { PTLI1005003S } from "@/tra/tancis/ptli/ptl/auth/PTLI1005003S";
import { PTLI1002001Q } from "@/tra/tancis/ptli/ptl/scrn/PTLI1002001Q";
import { PTLI1002002S } from "@/tra/tancis/ptli/ptl/scrn/PTLI1002002S";
import { PTLI1002003S } from "@/tra/tancis/ptli/ptl/scrn/PTLI1002003S";
import { PTLI1015001Q } from "@/tra/tancis/ptli/ptl/authmenu/PTLI1015001Q";
import { PTLI1015002S } from "@/tra/tancis/ptli/ptl/authmenu/PTLI1015002S";
import { PTLI1016001Q } from "@/tra/tancis/ptli/ptl/roleauth/PTLI1016001Q";
import { PTLI1016002S } from "@/tra/tancis/ptli/ptl/roleauth/PTLI1016002S";
import { PTLI1010001Q } from "@/tra/tancis/ptli/ptl/noti/PTLI1010001Q";
import { PTLI1010002S } from "@/tra/tancis/ptli/ptl/noti/PTLI1010002S";
import { PTLI1010003S } from "@/tra/tancis/ptli/ptl/noti/PTLI1010003S";
import { PTLI1006001S } from "@/tra/tancis/ptli/ptl/cstmrole/PTLI1006001S";
import { PTLI1007001Q } from "@/tra/tancis/ptli/ptl/cstmauth/PTLI1007001Q";
import { PTLI1007002S } from "@/tra/tancis/ptli/ptl/cstmauth/PTLI1007002S";
import { PTLI0801001Q } from "@/tra/tancis/ptli/ptl/ntcmgmt/PTLI0801001Q";
import { PTLI0801002S } from "@/tra/tancis/ptli/ptl/ntcmgmt/PTLI0801002S";
import { PTLI0411001Q } from "@/tra/tancis/ptli/ptl/manl/PTLI0411001Q";
import { PTLI0411002S } from "@/tra/tancis/ptli/ptl/manl/PTLI0411002S";
import { PTLI0411003S } from "@/tra/tancis/ptli/ptl/manl/PTLI0411003S";
import {PTLI1009001Q} from "@/tra/tancis/ptli/ptl/authhist/PTLI1009001Q";
import {PTLI1009002Q} from "@/tra/tancis/ptli/ptl/authhist/PTLI1009002Q";
import {PTLI1008001Q} from "@/tra/tancis/ptli/ptl/orgauth/PTLI1008001Q";
import {PTLI1008002S} from "@/tra/tancis/ptli/ptl/orgauth/PTLI1008002S";

import {PTLI1030001Q} from "@/tra/tancis/ptli/ptl/usrrole/PTLI1030001Q";
import {PTLI1030002S} from "@/tra/tancis/ptli/ptl/usrrole/PTLI1030002S";
import {PTLI1003007Q} from "@/tra/tancis/ptli/ptl/rolehist/PTLI1003007Q";
import {PTLI1003008Q} from "@/tra/tancis/ptli/ptl/rolehist/PTLI1003008Q";
import {PTLI0707001Q} from "@/tra/tancis/ptli/ptl/revwprcss/PTLI0707001Q";
import {PTLI0707002S} from "@/tra/tancis/ptli/ptl/revwprcss/PTLI0707002S";
import {PTLI1008008Q} from "@/tra/tancis/ptli/ptl/cotpauth/PTLI1008008Q";
import {PTLI1008012Q} from "@/tra/tancis/ptli/ptl/cotpauth/PTLI1008012Q";
import {PTLI1008013S} from "@/tra/tancis/ptli/ptl/cotpauth/PTLI1008013S";





/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */
export const PtlRouter = () => {
    return (
        <Routes>
            {/** ==================== Role Management Router START ==================== */}

            {/* Role Management List !== 역할 관리 목록 ==! */}
            <Route path={"/role/ptli1004001q"} element={<PTLI1004001Q />} />
            {/* Role Management Registration !== 역할 관리 등록 ==! */}
            <Route path={"/role/ptli1004002s"} element={<PTLI1004002S />} />
            {/* Role Management Details !== 역할 관리 상세 ==! */}
            <Route path={"/role/ptli1004003s/:roleId"} element={<PTLI1004003S />} />
                <Route path={"/role-hist/ptli1003007q"} element={<PTLI1003007Q />} />
                <Route path={"/role-hist/ptli1003008q/:usrDmnId"} element={<PTLI1003008Q />} />

            {/** ==================== Role Management Router END ==================== */}

            {/** ==================== Role and Auth Link Router START ==================== */}

            {/* Role and Auth Link List !== 역할 및 권한 연결 목록 ==! */}
            <Route path={"/role-auth/ptli1016001q"} element={<PTLI1016001Q />} />

            {/* Role and Auth Link Detail !== 역할 및 권한 연결 상세 ==! */}
            <Route path={"/role-auth/ptli1016002s/:roleId"} element={<PTLI1016002S />} />

            {/** ==================== Role and Auth Link Router END ==================== */}

                {/** ==================== Company Code Auth Link Router START ==================== */}

                <Route path={"/cotp-auth/ptli1008008q"} element={<PTLI1008008Q />} />
                <Route path={"/cotp-auth/ptli1008012q/:authId"} element={<PTLI1008012Q />} />
                <Route path={"/cotp-auth/ptli1008013s"} element={<PTLI1008013S />} />

                {/** ==================== Company Code Auth Link Router END ==================== */}


            {/** ==================== Auth Management Router START ==================== */}

            {/* Auth Management List !== 권한 관리 목록 ==! */}
            <Route path={"/auth/ptli1005001q"} element={<PTLI1005001Q />} />
            {/* Auth Management Registration !== 권한 관리 등록 ==! */}
            <Route path={"/auth/ptli1005002s"} element={<PTLI1005002S />} />
            {/* Auth Management Details !== 권한 관리 상세 ==! */}
            <Route path={"/auth/ptli1005003s/:authId"} element={<PTLI1005003S />} />

            {/** ==================== Auth Management Router END ==================== */}

            {/** ==================== Notifice Management Router START ==================== */}

            {/* Select. Notifice List !== 화면 목록 조회 ==! */}
            <Route path={"/noti/ptli1010001q"} element={<PTLI1010001Q />} />
            {/* Create. Notifice Info !== 화면 정보 생성 ==! */}
            <Route path={"/noti/ptli1010002s"} element={<PTLI1010002S />} />
            {/* Save. Notifice Info !== 화면 정보 저장 ==! */}
            <Route path={"/noti/ptli1010003s/:notiId"} element={<PTLI1010003S />} />

            {/** ==================== Screen Management Router END ==================== */}

            {/** ==================== Auth and Menu Link Router START ==================== */}

            {/* Auth and Menu Link List !== 권한 및 메뉴 연결 목록 ==! */}
            <Route path={"/auth-menu/ptli1015001q"} element={<PTLI1015001Q />} />

            {/* Auth and Menu Link Detail !== 권한 및 메뉴 연결 상세 ==! */}
            <Route path={"/auth-menu/ptli1015002s/:authId"} element={<PTLI1015002S />} />

            {/** ==================== Auth and Menu Link Router END ==================== */}

            {/** ==================== Menu Management Router START ==================== */}

            {/* Select. Menu List !== 메뉴 목록 조회 ==! */}
            <Route path={"/menu/ptli1001001q"} element={<PTLI1001001Q />} />
            {/* Create. Menu Info !== 메뉴 정보 생성 ==! */}
            <Route path={"/menu/ptli1001002s/:uprMenuId?"} element={<PTLI1001002S />} />
            {/* Save. Menu Info !== 메뉴 정보 저장 ==! */}
            <Route path={"/menu/ptli1001003s/:menuId"} element={<PTLI1001003S />} />

            {/** ==================== Menu Management Router END ==================== */}

            {/** ==================== Screen Management Router START ==================== */}

            {/* Select. Screen List !== 화면 목록 조회 ==! */}
            <Route path={"/scrn/ptli1002001q"} element={<PTLI1002001Q />} />
            {/* Create. Screen Info !== 화면 정보 생성 ==! */}
            <Route path={"/scrn/ptli1002002s"} element={<PTLI1002002S />} />
            {/* Save. Screen Info !== 화면 정보 저장 ==! */}
            <Route path={"/scrn/ptli1002003s/:scrnId"} element={<PTLI1002003S />} />

            {/** ==================== Screen Management Router END ==================== */}

            {/** ==================== Menu Screen Management Router START ==================== */}

            {/* Menu and Screen List !== 메뉴화면 연결 목록 ==! */}
            <Route path={"/menu-scrn/ptli1003001q"} element={<PTLI1003001Q />} />
            {/* Menu and Screen Detail !== 메뉴화면 연결 상세 ==! */}
            <Route path={"/menu-scrn/ptli1003002s/:menuId"} element={<PTLI1003002S />} />

            {/** ==================== Menu Screen Management Router END ==================== */}

            {/** ==================== Label Language Router START ==================== */}

            {/* Label Language List !== 라벨 언어 목록 ==! */}
            <Route path={"/lbl/ptli1014001q"} element={<PTLI1014001Q />} />

            {/* Label Language Registration !== 라벨 언어 등록 ==! */}
            <Route path={"/lbl/ptli1014002s"} element={<PTLI1014002S />} />

            {/* Label Language Change !== 라벨 언어 수정 ==! */}
            <Route path={"/lbl/ptli1014003s/:lblId"} element={<PTLI1014003S />} />

            {/** ==================== Label Language Router END ==================== */}


            {/** ==================== Review Process Management Router START ==================== */}

                <Route path={"/revwprcs/ptli0707001q"} element={<PTLI0707001Q />}></Route>

                <Route path={"/revwprcs/ptli0707002s"} element={<PTLI0707002S />}></Route>

                <Route path={"/revwprcs/ptli0707002s/:usrFdbckPrcssId"} element={<PTLI0707002S />}></Route>

            {/** ==================== Review Process Management Router END ==================== */}


            {/** ==================== Bulletin board Management Router START ==================== */}

            {/** Bulletin board Management List !== 게시판 관리 목록 ==! */}
            <Route path={"/bltbrd/ptli1017001q"} element={<PTLI1017001Q />} />

            {/** Bulletin board Management Registration !== 게시판 관리 등록 ==! */}
            <Route path={"/bltbrd/ptli1017002s"} element={<PTLI1017002S />} />

            {/** Bulletin board Management Change !== 게시판 관리 수정 ==! */}
            <Route path={"/bltbrd/ptli1017003s/:bltbrdUuid"} element={<PTLI1017003S />} />

            {/** Bulletin board Type Code Popup !== 게시판 유형코드 팝업 ==! */}
            <Route path={"/bltbrd/ptli1017004q"} element={<PTLI1017004Q />} />

            {/** Bulletin board Popup !== 게시판 팝업 ==! */}
            <Route path={"/bltbrd/ptli1017005q"} element={<PTLI1017005Q />} />
            {/** ====================  Bulletin board Management Router END ==================== */}

            {/** ==================== common Bulletin board Router START ==================== */}

            {/* Common Bulletin board(Bulletin board message) List !== 공통 게시판 (게시글) 목록 ==! */}
            <Route path={"/btbdms/ptli1018001q"} element={<PTLI1018001Q />} />

            {/* Common Bulletin Board(Bulletin board message) Detail !== 공통 게시판(게시글) 상세 ==! */}
            <Route path={"/btbdms/ptli1018002q/:bltbrdUuid/:btbdmsId"} element={<PTLI1018002Q />} />

            {/* Common Bulletin Board(Bulletin board message) Registration !== 공통 게시판(게시글) 등록 ==! */}
            <Route path={"/btbdms/ptli1018003s/:bltbrdUuid"} element={<PTLI1018003S />} />

            {/* Common Bulletin Board(Bulletin board message) Modification !== 공통 게시판(게시글) 수정 ==! */}
            <Route path={"/btbdms/ptli1018004s/:bltbrdUuid/:btbdmsId"} element={<PTLI1018004S />} />

            {/** ====================  common bltbrd Router END ==================== */}

            {/** ==================== Linking Customs Roles Router START ==================== */}

            <Route path={"/cstm-role/ptli1006001s"} element={<PTLI1006001S />} />

            {/** ==================== Linking Customs Roles Router END ==================== */}

            {/** ==================== Customs User Auth Router START ==================== */}

            {/* Customs User Auth List !== 세관 사용자 권한 목록 ==! */}
            <Route path={"/cstm-auth/ptli1007001q"} element={<PTLI1007001Q />} />
            {/* Customs User Auth Registration !== 세관 사용자 권한 등록 ==! */}
            <Route path={"/cstm-auth/ptli1007002s/:usrDmnId"} element={<PTLI1007002S />} />

            {/** ==================== Customs User Auth Router END ==================== */}

            {/** ==================== Customs User Auth History Router START ==================== */}

            {/* Customs User Auth List !== 세관 사용자 권한 목록 ==! */}
            <Route path={"/auth-hist/ptli1009001q"} element={<PTLI1009001Q />} />
            {/* Customs User Auth Registration !== 세관 사용자 권한 등록 ==! */}
            <Route path={"/auth-hist/ptli1009002q/:usrDmnId"} element={<PTLI1009002Q />} />

            {/** ==================== Customs User Auth History Router END ==================== */}

            {/** ==================== OGA User Auth Router START ==================== */}

            {/* OGA User Auth List !== 기관 사용자 권한 목록 ==! */}
            <Route path={"/org-auth/ptli1008001q"} element={<PTLI1008001Q />} />
            {/* OGA User Auth Registration !== 기관 사용자 권한 등록 ==! */}
            <Route path={"/org-auth/ptli1008002s/:tin"} element={<PTLI1008002S />} />

            {/** ==================== OGA User Auth Router END ==================== */}

            {/** ==================== Notice Management Router START ==================== */}

            {/* Notice Management List !== 공지•통지 목록 ==! */}
            <Route path={"/ntcmgmt/ptli0801001q"} element={<PTLI0801001Q />} />
            {/* Notice Management Details !== 공지•통지 상세 ==! */}
            <Route path={"/ntcmgmt/ptli0801002s/:notiSendUuid"} element={<PTLI0801002S />} />

            {/** ==================== Notice Management Router END ==================== */}


            {/** ==================== 메뉴얼 목록조회 ==================== */}
            <Route path="/manl/ptli0411001q" element={<PTLI0411001Q />} />
            <Route path="/manl/ptli0411002s" element={<PTLI0411002S />} />
            <Route path="/manl/ptli0411003s/:scrnId" element={<PTLI0411003S />} />

            {/** ==================== Internal user role 내부 사용자 계정처리현황 목록조회 ==================== */}
            <Route path="/usr-role/ptli1030001q" element={<PTLI1030001Q />} />
            <Route path="/usr-role/ptli1030002s/:usrDmnId" element={<PTLI1030002S />} />
        </Routes>
    );
};
